import { ICriteriaCommand } from "@Criteria/cqrs";

export class CreateWeightedScoreCommandV1 implements ICriteriaCommand {
	$type: string = 'TCh.Domain.Criteria.WeightedScores.Commands.CreateWeightedScoreCommandV1, TCh.Domain.Criteria';

	WorkspaceId: number;

	Id: string;
	CriteriaHierarchyId: number;
	CriteriaWeightsSetId: number;
	CriterionId: number;
	Name: string;
	Description: string;

	constructor(workspaceId: number, scoreId: string, chId: number, weightsSetId: number, criterionId: number, name: string, desc: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = scoreId;
		this.CriteriaHierarchyId = chId;
		this.CriteriaWeightsSetId = weightsSetId;
		this.CriterionId = criterionId;
		this.Name = name;
		this.Description = desc;		
	}

	static matchType(cmd: ICriteriaCommand)	{
		return cmd.$type == 'TCh.Domain.Criteria.WeightedScores.Commands.CreateWeightedScoreCommandV1, TCh.Domain.Criteria'
	}
}

export class UpdateWeightedScoreCommandV1 implements ICriteriaCommand
{
	$type: string = 'TCh.Domain.Criteria.WeightedScores.Commands.UpdateWeightedScoreCommandV1, TCh.Domain.Criteria';

	WorkspaceId: number;

	Id: string;
	CriteriaWeightsSetId: number;
	CriterionId: number;
	Name: string;
	Description: string;

	constructor(workspaceId: number, scoreId: string, weightsSetId: number, criterionId: number, name: string, desc: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = scoreId;
		this.CriteriaWeightsSetId = weightsSetId;
		this.CriterionId = criterionId;
		this.Name = name;
		this.Description = desc;
	}

	static matchType(cmd: ICriteriaCommand)
	{
		return cmd.$type == 'TCh.Domain.Criteria.WeightedScores.Commands.UpdateWeightedScoreCommandV1, TCh.Domain.Criteria'
	}
}